// API route constants

export const ApiRoutes = {
  Auth: {
    Login: '/api/Auth/GetTokenByUsernamePassword',
    RefreshToken: '/api/Auth/RefreshToken',
    RequestPasswordReset: '/api/Auth/RequestPasswordReset',
    ValidatePasswordResetToken: '/api/Auth/ValidatePasswordResetToken',
    ResetPassword: '/api/Auth/ResetPassword'
  },
  Lookup: {
    GetLookupTypes: '/api/Lookup/GetLookupTypes',
    GetLookupsByType: '/api/Lookup/GetLookupsByType',
    GetLookupById: '/api/Lookup/GetLookupListItem',
    SaveLookup: '/api/Lookup/SaveLookup'
  },
  Booking: {
    GetBookings: '/api/Booking/GetBookings',
    GetPublicHolidays: '/api/Booking/GetPublicHolidays',
    GetClientBookings: '/api/Booking/GetClientBookings',
    GetEmployeeBookings: '/api/Booking/GetEmployeeBookings',
    GetUpcomingClientBookings: '/api/Booking/GetUpcomingClientBookings',
    GetUpcomingEmployeeBookings: '/api/Booking/GetUpcomingEmployeeBookings',
    GetBookingById: '/api/Booking/GetBookingById',
    CreateBooking: '/api/Booking/CreateBooking',
    UpdateBooking: '/api/Booking/UpdateBooking',
    UpdateBookingNotes: '/api/Booking/UpdateBookingNotes',
    CancelBooking: '/api/Booking/CancelBooking',
    DeleteBooking: '/api/Booking/DeleteBooking',
    PreviewBulkBookingAvailability: '/api/Booking/PreviewBulkBookingAvailability',
    CreateBulkBookings: '/api/Booking/CreateBulkBookings',
    GetBookingsByDateRange: '/api/Booking/GetBookingsByDateRange',
    CreateBulkAvailableSlots: '/api/Booking/CreateBulkAvailableSlots',
    CreatePublicHoliday: '/api/Booking/CreatePublicHoliday',
    UpdatePublicHoliday: '/api/Booking/UpdatePublicHoliday',
    DeletePublicHoliday: '/api/Booking/DeletePublicHoliday',
    ApproveBooking: '/api/Booking/ApproveBooking',
    RejectBooking: '/api/Booking/RejectBooking',
    // Waitlist endpoints
    GetWaitlist: '/api/Booking/GetWaitlist',
    CreateWaitlistEntry: '/api/Booking/CreateWaitlistEntry',
    DeleteWaitlistEntry: '/api/Booking/DeleteWaitlistEntry'
  },
  Client: {
    GetClients: '/api/Client/GetClients',
    SearchClients: '/api/Client/SearchClients',
    GetClientById: '/api/Client/GetClientById',
    GetBookingParticipantOptions: '/api/Client/GetBookingParticipantOptions',
    GetMyBookingParticipantOptions: '/api/Client/GetMyBookingParticipantOptions',
    CreateClient: '/api/Client/CreateClient',
    UpdateClient: '/api/Client/UpdateClient',
    DeleteClient: '/api/Client/DeleteClient',
    GetClientChildren: '/api/Client/GetClientChildren',
    GetClientChildById: '/api/Client/GetClientChildById',
    CreateClientChild: '/api/Client/CreateClientChild',
    UpdateClientChild: '/api/Client/UpdateClientChild',
    DeleteClientChild: '/api/Client/DeleteClientChild',
    PromoteClientChild: '/api/Client/PromoteClientChild',
    // Client Invitation endpoints
    CreateInvitation: '/api/Client/CreateInvitation',
    ValidateInvitationToken: '/api/Client/ValidateInvitationToken',
    GetInvitationByToken: '/api/Client/GetInvitationByToken',
    CompleteInvitation: '/api/Client/CompleteInvitation',
    ResendInvitation: '/api/Client/ResendInvitation'
  },
  Service: {
    GetServices: '/api/Service/GetServices',
    GetServiceById: '/api/Service/GetServiceById',
    CreateService: '/api/Service/CreateService',
    UpdateService: '/api/Service/UpdateService',
    DeleteService: '/api/Service/DeleteService',
    GetServiceRequiredSkills: '/api/Service/GetServiceRequiredSkills',
    SaveServiceRequiredSkills: '/api/Service/SaveServiceRequiredSkills',
    CanEmployeeProvideService: '/api/Service/CanEmployeeProvideService',
    GetQualifiedEmployeesForService: '/api/Service/GetQualifiedEmployeesForService'
  },
  Employee: {
    GetEmployees: '/api/Employee/GetEmployees',
    GetEmployeeById: '/api/Employee/GetEmployeeById',
    CreateEmployee: '/api/Employee/CreateEmployee',
    UpdateEmployee: '/api/Employee/UpdateEmployee',
    DeleteEmployee: '/api/Employee/DeleteEmployee',
    GetEmployeeUnavailability: '/api/Employee/GetEmployeeUnavailability',
    CreateUnavailability: '/api/Employee/CreateUnavailability',
    DeleteUnavailability: '/api/Employee/DeleteUnavailability',
    GetAbsencesByEmployeeIdAndDateRange: '/api/Employee/GetAbsencesByEmployeeIdAndDateRange',
    GetAbsencesForCalendar: '/api/Employee/GetAbsencesForCalendar',
    GetEmployeeSchedule: '/api/Employee/GetEmployeeSchedule',
    CreateSchedule: '/api/Employee/CreateSchedule',
    UpdateSchedule: '/api/Employee/UpdateSchedule',
    DeleteSchedule: '/api/Employee/DeleteSchedule',
    GetEmployeeQualifications: '/api/Employee/GetEmployeeQualifications',
    SaveEmployeeQualifications: '/api/Employee/SaveEmployeeQualifications',
    GetQualifiedEmployeesForService: '/api/Employee/GetQualifiedEmployeesForService',
    GetExpiringQualifications: '/api/Employee/GetExpiringQualifications',
    // My Schedule & Absences (Therapist Self-Management)
    GetMySchedule: '/api/Employee/GetMySchedule',
    CreateMySchedule: '/api/Employee/CreateMySchedule',
    UpdateMySchedule: '/api/Employee/UpdateMySchedule',
    DeleteMySchedule: '/api/Employee/DeleteMySchedule',
    GetMyAbsences: '/api/Employee/GetMyAbsences',
    CreateMyAbsence: '/api/Employee/CreateMyAbsence',
    UpdateMyAbsence: '/api/Employee/UpdateMyAbsence',
    DeleteMyAbsence: '/api/Employee/DeleteMyAbsence',
    // Employee Invitation
    SendInvitation: '/api/Employee/SendInvitation',
    ValidateInvitationToken: '/api/Employee/ValidateInvitationToken',
    GetInvitationByToken: '/api/Employee/GetInvitationByToken',
    CompleteInvitation: '/api/Employee/CompleteInvitation'
  },
  // Reserved namespace for future dedicated waitlist controller (phase later)
  Waitlist: {
    CreateInvite: '/api/Waitlist/CreateInvite',
    GetInvitesForSlot: '/api/Waitlist/GetInvitesForSlot',
    AcceptInvite: '/api/Waitlist/AcceptInvite',
    DeclineInvite: '/api/Waitlist/DeclineInvite'
  },
  Qualification: {
    GetQualifications: '/api/Qualification/GetQualifications',
    GetQualification: '/api/Qualification/GetQualification',
    CreateQualification: '/api/Qualification/CreateQualification',
    UpdateQualification: '/api/Qualification/UpdateQualification',
    DeleteQualification: '/api/Qualification/DeleteQualification'
  },
  Room: {
    GetRooms: '/api/Booking/GetRooms',
    GetRoomById: '/api/Booking/GetRoomById',
    CreateRoom: '/api/Booking/CreateRoom',
    UpdateRoom: '/api/Booking/UpdateRoom',
    DeleteRoom: '/api/Booking/DeleteRoom',
    GetRoomFutureBookingCount: '/api/Booking/GetRoomFutureBookingCount'
  },
  User: {
    GetUsers: '/api/User/GetUsers',
    GetAvailableUsersForEmployee: '/api/User/GetAvailableUsersForEmployee',
    GetUser: '/api/User/GetUser',
    CreateUser: '/api/User/CreateUser',
    UpdateUser: '/api/User/UpdateUser',
    UnlinkUserRelation: '/api/User/UnlinkUserRelation',
    DeleteUser: '/api/User/DeleteUser',
    GetMyProfile: '/api/User/GetMyProfile',
    UpdateMyProfile: '/api/User/UpdateMyProfile',
    ChangePassword: '/api/User/ChangePassword',
    GetProfileHistory: '/api/User/GetProfileHistory',
    InitiatePasswordReset: '/api/User/InitiatePasswordReset'
  },
  Role: {
    GetRoles: '/api/Role/GetRoles',
    GetRole: '/api/Role/GetRole',
    GetPrivileges: '/api/Role/GetPrivileges',
    GetRolePrivileges: '/api/Role/GetRolePrivileges',
    CreateRole: '/api/Role/CreateRole',
    UpdateRole: '/api/Role/UpdateRole',
    DeleteRole: '/api/Role/DeleteRole'
  },
  Security: {
    GetMyLoginAttempts: '/api/Security/GetMyLoginAttempts',
    GetMySessions: '/api/Security/GetMySessions',
    InvalidateSession: '/api/Security/InvalidateSession',
    CheckAccountLockout: '/api/Security/CheckAccountLockout',
    GetSecurityAuditLog: '/api/Security/GetSecurityAuditLog',
    GetLockoutHistory: '/api/Security/GetLockoutHistory'
  },
  // Suggestion Management API Routes
  Suggestion: {
    GetClientSuggestions: '/api/Suggestion/GetClientSuggestions',
    GetTherapistSuggestions: '/api/Suggestion/GetTherapistSuggestions',
    GetSuggestionById: '/api/Suggestion/GetSuggestionById',
    CreateSuggestion: '/api/Suggestion/CreateSuggestion',
    UpdateSuggestion: '/api/Suggestion/UpdateSuggestion',
    DeleteSuggestion: '/api/Suggestion/DeleteSuggestion',
    MarkAsCompleted: '/api/Suggestion/MarkAsCompleted'
  },
  // Notification Management API Routes
  Notification: {
    GetUnreadNotifications: '/api/Notification/GetUnreadNotifications',
    MarkAsRead: '/api/Notification/MarkAsRead',
    GetAllNotifications: '/api/Notification/GetAllNotifications',
    ResendNotification: '/api/Notification/ResendNotification'
  },
  // Reports API Routes
  Report: {
    GetClientServiceVisitsReport: '/api/Report/GetClientServiceVisitsReport',
    GetBookingCancellationsReport: '/api/Report/GetBookingCancellationsReport'
  },
  // Public Booking API Routes (no authentication required)
  PublicBooking: {
    GetPublicServices: '/api/PublicBooking/GetPublicServices',
    GetServiceCategories: '/api/PublicBooking/GetServiceCategories',
    GetAvailableTimeSlots: '/api/PublicBooking/GetAvailableTimeSlots',
    GetAvailableTimeSlotsByCategory: '/api/PublicBooking/GetAvailableTimeSlotsByCategory',
    GetServiceByCategoryAndClientType: '/api/PublicBooking/GetServiceByCategoryAndClientType'
  },
  // Payment API Routes (Montonio integration)
  Payment: {
    InitiatePayment: '/api/Payment/InitiatePayment',
    ValidatePaymentReturn: '/api/Payment/ValidatePaymentReturn',
    CreateBookingWithoutPayment: '/api/Payment/CreateBookingWithoutPayment',
    CreateBookingWithServicePass: '/api/Payment/CreateBookingWithServicePass'
  },
  // Service Pass Management API Routes
  ServicePass: {
    GetAllServicePasses: '/api/ServicePass/GetAllServicePasses',
    GetServicePasses: '/api/ServicePass/GetServicePasses',
    GetServicePassById: '/api/ServicePass/GetServicePassById',
    CreateServicePass: '/api/ServicePass/CreateServicePass',
    UpdateServicePass: '/api/ServicePass/UpdateServicePass',
    DeleteServicePass: '/api/ServicePass/DeleteServicePass'
  },
  // Client Service Pass Management API Routes
  ClientServicePass: {
    GetAllClientServicePasses: '/api/ClientServicePass/GetAllClientServicePasses',
    GetClientPasses: '/api/ClientServicePass/GetClientPasses',
    GetClientChildPasses: '/api/ClientServicePass/GetClientChildPasses',
    GetActivePassForService: '/api/ClientServicePass/GetActivePassForService',
    GetActivePassesForService: '/api/ClientServicePass/GetActivePassesForService',
    PurchasePass: '/api/ClientServicePass/PurchasePass',
    GetPassUsageHistory: '/api/ClientServicePass/GetPassUsageHistory',
    AddPassUsageBooking: '/api/ClientServicePass/AddPassUsageBooking',
    GetClientServicePassById: '/api/ClientServicePass/GetClientServicePassById',
    UpdatePassStatus: '/api/ClientServicePass/UpdatePassStatus',
    UpdateClientServicePass: '/api/ClientServicePass/UpdateClientServicePass',
    DeleteClientServicePass: '/api/ClientServicePass/DeleteClientServicePass'
  }
} as const;
